import Brand from "@/components/Brand";
import { BrandDetailItemProps } from "@/components/Brand/constants";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import axios from "axios";
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from "next";
import { ParsedUrlQuery } from 'querystring';


interface BrandProps {
  brand: BrandDetailItemProps;
}

interface BrandParams extends ParsedUrlQuery {
  slug: string;
}

const BrandPage = ({
  brand,
}: BrandProps) => {

  if (brand === undefined) return (<></>)

  return (
    <>
      <Header />
      <Brand
        slug={brand.slug}
        main_banner={brand.main_banner}
        our_picks={brand.our_picks}
        people_say={brand.people_say}
        instagram={brand.instagram}
        shopping_category={brand.shopping_category}
        info_banner={brand.info_banner}
        shopping_banners={brand.shopping_banners}
      />
      <Footer />
    </>
  )
}

export default BrandPage

export const getStaticProps: GetStaticProps<BrandParams> = async ({ params }) => {
  const { slug } = params;
  const response = await axios.get(
    process.env.NEXT_PUBLIC_API_URL! + process.env.NEXT_PUBLIC_API_BRAND! + "/" + slug
  );

  return {
    props: { brand: response.data },
    revalidate: 60,
  }
}

export const getStaticPaths: GetStaticPaths<BrandParams> = async () => {
  const slugs = ["mooimom", "mugu", "tweeling", "nero-bianco"]

  const paths = slugs.map((slug: string) => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: true,
  };
};
